import { action, makeObservable, observable, onBecomeObserved } from "mobx"

import { bankAccountsApi, catchErrors, tokensApi } from "@src/shared/api"
import { BankAccountResponse, Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

type TokensCollectionLoadType = {
  page?: number
}

export class BankDetailsCollection extends loading(
  ["fetch", "delete", "create"],
  CollectionWithPagination<BankAccountResponse>,
) {
  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
    })

    const kill = onBecomeObserved(this, "isLoading", () => {
      kill()

      return this.load()
    })
  }

  async delete(id: string) {
    return bankAccountsApi.deleteBankAccount(id).then(this.load)
  }

  async fetch(req: TokensCollectionLoadType) {
    try {
      const { data: { data } = {} } = await bankAccountsApi.getBankAccounts(
        undefined,
        this.calcOffset(req.page),
        this.pageSize,
      )

      if (data) {
        const { data: items, pagination } = data as any

        return {
          data: items as BankAccountResponse[],
          pagination: pagination as Pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }
}
